export const appPageTransition = {"name":"page","mode":"out-in"}

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":"Tradel is an Australian-owned, on-demand delivery platform built for trade, construction, and retail."},{"property":"og:site_name","content":"Tradel"},{"property":"og:type","content":"website"},{"property":"og:title","content":"Tradel | Trade delivery, done right."},{"property":"og:description","content":"Tradel is an Australian-owned, on-demand delivery platform built for trade, construction, and retail."},{"property":"og:image","content":"https://app.tradel.com.au/logo.png"},{"name":"twitter:card","content":"summary"},{"name":"twitter:title","content":"Tradel | Trade delivery, done right."},{"name":"twitter:description","content":"Tradel is an Australian-owned, on-demand delivery platform built for trade, construction, and retail."},{"name":"twitter:image","content":"https://app.tradel.com.au/logo.png"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-title","content":"Tradel"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"}],"link":[{"rel":"apple-touch-icon","href":"/pwa-512x512.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/pwa-192x192.png"},{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":""},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&display=swap"}],"style":[],"script":[{"src":"/theme-boot.js","tagPosition":"head","tagPriority":"critical"},{"innerHTML":"!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','1542228754264552');fbq('track','PageView');","tagPosition":"head"}],"noscript":[{"innerHTML":"<img height=\"1\" width=\"1\" style=\"display:none\" src=\"https://www.facebook.com/tr?id=1542228754264552&ev=PageView&noscript=1\"/>"}],"title":"Trade delivery, done right.","titleTemplate":"%s | Tradel"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true